<template>
  <epi-picture
    slot="media"
    v-edit="'Image'"
    :image="adaptiveImage"
    :float-setting="floatSetting"
    :sharpen="80"
    auto-quality="best"
  />
</template>

<script>
export default {
  props: {
    adaptiveImage: {
      type: Object,
      default: null
    },
    floatSetting: {
      type: String,
      default: 'Default'
    }
  }
}
</script>
